export type GuideCard = {
  id: string;
  title: { sv: string; en: string };
  description: { sv: string; en: string };
  /** Internal certificate slug, or a full relative path starting with / */
  target: string;
  group: { sv: string; en: string };
};

export const guideCards: GuideCard[] = [
  {
    id: "sjofolk-manila",
    group: { sv: "Sjöfolk", en: "Seafarers" },
    title: { sv: "Vad är ett Manila/STCW-intyg?", en: "What is a Manila/STCW medical certificate?" },
    description: {
      sv: "Förstå vad sjöfolksintyget gäller, vem som behöver det och hur befattning och fartområde påverkar undersökningen.",
      en: "What a Swedish seafarer medical covers, who needs it and why your role and trading area matter.",
    },
    target: "/guider/sjofolk/manila-stcw",
  },
  {
    id: "sjofolk-horsel",
    group: { sv: "Sjöfolk", en: "Seafarers" },
    title: { sv: "Hörseltest för sjöfolksintyg", en: "Hearing tests for a seafarer medical" },
    description: {
      sv: "När hörseltest behövs, vad det kostar och hur undersökningen går till.",
      en: "When a hearing test is required, what it costs and how the examination works.",
    },
    target: "/guider/sjofolk/horseltest",
  },
  {
    id: "hogre-syn",
    group: { sv: "Högre behörighet", en: "Higher driving licence" },
    title: { sv: "Syntest för buss- och lastbilsintyg", en: "Vision tests for truck and bus medical certificates" },
    description: {
      sv: "Så fungerar syntest på mottagningen och separata synuppgifter när du väljer läkarbesök via video.",
      en: "Vision tests at the clinic and the separate vision information needed for video appointments.",
    },
    target: "/guider/hogre-behorighet/synintyg",
  },
  {
    id: "hogre-horsel",
    group: { sv: "Högre behörighet", en: "Higher driving licence" },
    title: { sv: "Hörselkrav för buss och lastbil", en: "Hearing requirements for bus and truck licences" },
    description: {
      sv: "Skillnaden mellan C- och D-behörigheter, hur hörseln prövas och vad det betyder för ditt besök.",
      en: "How hearing requirements differ between truck and bus categories and how the assessment is arranged.",
    },
    target: "/guider/hogre-behorighet/horselkrav",
  },
  {
    id: "alkolas",
    group: { sv: "Alkohol & droger", en: "Alcohol & drugs" },
    title: { sv: "Alkolås – guide till prover och intyg", en: "Alcohol interlock – guide to tests and certificates" },
    description: {
      sv: "Från inskrivning till färdigt intyg. Ansökan, läkarbesök, prover och villkorstid.",
      en: "From application to finished certificate. Application, doctor visit, tests and conditional period.",
    },
    target: "/guider/alkolas/guide",
  },
  {
    id: "droger",
    group: { sv: "Alkohol & droger", en: "Alcohol & drugs" },
    title: { sv: "Alkohol- och drogintyg", en: "Alcohol and drug certificates" },
    description: {
      sv: "När Transportstyrelsen kräver prover, hur bedömningen går till och vad du behöver förbereda.",
      en: "When the Swedish Transport Agency requires tests, how the assessment works and what to prepare.",
    },
    target: "droger-alkohol",
  },
  {
    id: "diabetes",
    group: { sv: "Medicinska tillstånd", en: "Medical conditions" },
    title: { sv: "Diabetes och körkort – vad behöver bedömas?", en: "Diabetes and driving licence – what needs assessing?" },
    description: {
      sv: "Om behandlingen, körkortsbehörigheten och underlagen som läkaren behöver vid ditt besök.",
      en: "About treatment, licence category and the documents the doctor needs at your visit.",
    },
    target: "/guider/diabetes/krav-och-bedomning",
  },
  {
    id: "hjarta",
    group: { sv: "Medicinska tillstånd", en: "Medical conditions" },
    title: { sv: "Hjärt- och kärlsjukdom – bedömning för körkort", en: "Heart and vascular disease – driving licence assessment" },
    description: {
      sv: "Så påverkar frågeställningen vilket medicinskt underlag som behövs.",
      en: "How the questions in your case affect which medical documentation is needed.",
    },
    target: "/guider/hjarta-karl/krav-och-bedomning",
  },
  {
    id: "offshore-norge",
    group: { sv: "Offshore", en: "Offshore" },
    title: { sv: "Vad krävs för offshoreintyg i Norge?", en: "What is required for a Norwegian offshore medical?" },
    description: {
      sv: "Läs om norsk helseerklæring, godkänd petroleumslege och vad som händer efter den medicinska bedömningen.",
      en: "About the Norwegian health declaration, approved petroleum doctor and what happens after the assessment.",
    },
    target: "/guider/offshore-norge/krav-och-intyg",
  },
  {
    id: "oeuk",
    group: { sv: "Offshore", en: "Offshore" },
    title: { sv: "Vad är ett OEUK offshore medical?", en: "What is an OEUK offshore medical?" },
    description: {
      sv: "Förstå vad OEUK-intyget gäller, hur den medicinska bedömningen fungerar och vad vårt godkännande innebär.",
      en: "Understand what an OEUK certificate covers, how the assessment works and what our approval means.",
    },
    target: "/guider/oeuk/krav-och-intyg",
  },
  {
    id: "norge-eller-oeuk",
    group: { sv: "Offshore", en: "Offshore" },
    title: { sv: "Offshore Norge eller OEUK – vilket intyg behöver jag?", en: "Norwegian offshore or OEUK – which medical do you need?" },
    description: {
      sv: "Jämför de två intygen och priserna. Arbetsgivarens krav hjälper dig att välja rätt inför besöket.",
      en: "Compare the two certificates and prices. Your employer’s requirements help you choose before booking.",
    },
    target: "/guider/oeuk/norge-eller-oeuk",
  },
  {
    id: "nattarbete",
    group: { sv: "Arbetsmiljö", en: "Occupational health" },
    title: { sv: "Nattarbete – när behövs medicinsk kontroll?", en: "Night work – when is a medical examination required?" },
    description: {
      sv: "När kontrollen behövs, vad som undersöks och hur du förbereder dig inför besöket.",
      en: "When the examination is required, what is checked and how to prepare for your visit.",
    },
    target: "/guider/nattarbete/regler-och-kontroll",
  },
  {
    id: "forstadagsintyg",
    group: { sv: "Arbete", en: "Work" },
    title: { sv: "Förstadagsintyg – när behövs det?", en: "First-day certificate – when is it needed?" },
    description: {
      sv: "När arbetsgivaren begär intyg från första sjukdagen och hur besöket går till.",
      en: "When an employer requests a certificate from the first day of illness and how the visit works.",
    },
    target: "/guider/forstadagsintyg/intyg-till-arbetsgivaren",
  },
  {
    id: "fallskarm",
    group: { sv: "Sport", en: "Sport" },
    title: { sv: "Fallskärmsintyg – blankett och krav", en: "Parachuting medical – forms and requirements" },
    description: {
      sv: "Vilken blankett som behövs, när undersökningen bör göras och vad läkaren bedömer.",
      en: "Which form you need, when the examination should be done and what the doctor assesses.",
    },
    target: "/guider/fallskarm/blankett-och-krav",
  },
  {
    id: "adoption",
    group: { sv: "Adoption", en: "Adoption" },
    title: { sv: "Adoptionsintyg – hälsodeklaration och blankett", en: "Adoption medical – health declaration and forms" },
    description: {
      sv: "Så förbereder du hälsodeklaration och medicinskt underlag inför internationell adoption.",
      en: "How to prepare the health declaration and medical documentation for international adoption.",
    },
    target: "/guider/adoptionsintyg/blankett-och-krav",
  },
  {
    id: "visum-saudi",
    group: { sv: "Resor", en: "Travel" },
    title: { sv: "Läkarintyg inför visum till Saudiarabien", en: "Medical certificate for a Saudi Arabia visa" },
    description: {
      sv: "Förbered blankett och aktuella krav innan du bokar.",
      en: "Prepare the form and current requirements before you book.",
    },
    target: "/starta-arende?omrade=resor",
  },
  {
    id: "afs",
    group: { sv: "Arbetsmiljö", en: "Occupational health" },
    title: { sv: "AFS-undersökningar för arbetsgivare", en: "AFS examinations for employers" },
    description: {
      sv: "Medicinska kontroller enligt AFS 2023:15 – vibrationer, nattarbete, kemiska risker och mer.",
      en: "Medical examinations under AFS 2023:15 – vibration, night work, chemical risks and more.",
    },
    target: "/foretag/arbetsmiljo",
  },
  {
    id: "sa-fungerar",
    group: { sv: "Allmänt", en: "General" },
    title: { sv: "Så fungerar det hos Intygsläkaren", en: "How it works at Intygsläkaren" },
    description: {
      sv: "Ett tydligt flöde från rätt intyg och BankID till läkarbesök, prover och färdigt intyg.",
      en: "A clear flow from the right certificate and BankID to the doctor visit, tests and finished certificate.",
    },
    target: "/sa-fungerar-det",
  },
  {
    id: "infor-besoket",
    group: { sv: "Allmänt", en: "General" },
    title: { sv: "Inför besöket", en: "Before your visit" },
    description: {
      sv: "Video eller klinik i Göteborg – vad du behöver veta innan du kommer.",
      en: "Video or clinic in Gothenburg – what you need to know before you arrive.",
    },
    target: "/infor-besoket",
  },
];

export function guideGroups(lang: "sv" | "en") {
  const order: string[] = [];
  const map = new Map<string, GuideCard[]>();
  for (const card of guideCards) {
    const key = card.group[lang];
    if (!map.has(key)) {
      map.set(key, []);
      order.push(key);
    }
    map.get(key)!.push(card);
  }
  return order.map((title) => ({ title, cards: map.get(title)! }));
}
